module.exports = __webpack_public_path__ + "static/media/100144.137370d1.png";